
<index-panel
  page="Player"
  collection="players"
  :title="$route.params.name"
  :doc="$route.params.name"
/>
